/**
 * Manos F7-P3 — crisis band (placement A: above the product hero). Durable, non-blocking;
 * headline + subtext + 3 CTAs (Cómo ayudar / Buscar u ofrecer ayuda / Localizar a un
 * familiar) that route to the Centro de Crisis (F1 at /venezuela, same origin). Visible-face
 * policy (D8) is enforced by the manos i18n copy (no MayiLabs / individual / casualty).
 */
import type { Translations } from '../../types';

const CRISIS_HREF = '/venezuela';

export function ManosBand({ t }: { t: Translations }) {
  const ctas = [t.manos.ctaHelp, t.manos.ctaFindOffer, t.manos.ctaLocate];

  return (
    <section
      data-testid="manos-band"
      aria-label={t.manos.bandHeadline}
      className="bg-vinotinto-subtle border-b border-vinotinto/20"
    >
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-lg sm:text-xl font-bold text-vinotinto-dark">{t.manos.bandHeadline}</h2>
        <p className="mt-1 text-sm text-gray-700">{t.manos.bandSubtext}</p>
        <div className="mt-4 flex flex-wrap gap-3">
          {ctas.map((label) => (
            <a
              key={label}
              href={CRISIS_HREF}
              className="px-3 py-1.5 rounded-lg text-sm font-medium bg-vinotinto text-white hover:bg-vinotinto-dark transition-colors"
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
